import { Observable } from "rxjs";
import { HttpClientService } from "../service/http-client.service";
import { AddressAutocompletionRequestModel } from "../model/address-autocompletion/address-autocompletion-request.model";
import { AddressAutocompletionResponseModel } from "../model/address-autocompletion/address-autocompletion-response.model";

export class AddressAutocompletionRepo {
  /*
   * example endpoint
   * @see https://api.geoapify.com/v1/geocode/autocomplete?text=Bergstr+57518+Betzdorf&type=street&filter=countrycode:de&format=geojson&apiKey=d59ade6d8b40463fae046e6294d1c43d
   */
  protected static getEndpointUrl(): string {
    return "https://api.geoapify.com/v1/geocode/autocomplete";
  }

  protected static getApiKey(): string {
    return "d59ade6d8b40463fae046e6294d1c43d";
  }

  static getStreetSuggestionsByPostalCodeAndCity(
    text: string,
    countryCode: string,
    postalCode: string,
    city: string,
  ): Observable<AddressAutocompletionResponseModel> {
    const requestModel = new AddressAutocompletionRequestModel(); // still needed?
    requestModel.apiKey = this.getApiKey();
    requestModel.format = "geojson";
    requestModel.text = `${text} ${postalCode} ${city}`;
    requestModel.type = "street";

    const url = new URL(this.getEndpointUrl());
    const searchParams = new URLSearchParams();
    searchParams.set("apiKey", requestModel.apiKey);
    searchParams.set("format", requestModel.format);
    searchParams.set("text", requestModel.text);
    searchParams.set("type", requestModel.type);
    searchParams.set("filter", `countrycode:${countryCode || "de"}`);
    url.search = searchParams.toString();

    return HttpClientService.get(url.toString());
  }

  static getCityByPostalCode(
    postalCode: string,
    countryCode: string,
  ): Observable<AddressAutocompletionResponseModel> {
    const requestModel = new AddressAutocompletionRequestModel();
    requestModel.apiKey = this.getApiKey();
    requestModel.format = "geojson";
    requestModel.text = postalCode;

    const url = new URL(this.getEndpointUrl());
    const searchParams = new URLSearchParams();
    searchParams.set("apiKey", requestModel.apiKey);
    searchParams.set("format", requestModel.format);
    searchParams.set("text", requestModel.text);
    searchParams.set(
      "filter",
      `countrycode:${(countryCode || "de").toLowerCase()}`,
    );
    searchParams.set("lang", countryCode.toLowerCase());
    url.search = searchParams.toString();

    return HttpClientService.get(url.toString());
  }
}
